/** @flow */
import { spawn } from "redux-saga/effects";
import absenceRateSaga from "./absence-rate";
import complianceSaga from "./compliance";
import slaPerformanceSaga from "./sla-performance";
import spotlightSaga from "./spotlight";
import absenceReasonSaga from "./absence-reason";

export default function* trendsSaga(): Generator<*, void, void> {
  yield spawn(absenceRateSaga);
  yield spawn(complianceSaga);
  yield spawn(slaPerformanceSaga);
  yield spawn(spotlightSaga);
  yield spawn(absenceReasonSaga);
}
